import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchFlashDealsProductsAPI } from "./flashDealsAPI";

export const fetchFlashDealsProductsData = createAsyncThunk(
    "flashDeals/fetchFlashDealsProductsData",
    async () => {
        const data = await fetchFlashDealsProductsAPI();
        return data
    }
)

const flashDealsSlice = createSlice({
    name: "flashDealsproducts",
    initialState: {
        flashDealsproducts: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchFlashDealsProductsData.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchFlashDealsProductsData.fulfilled, (state, action) => {
            state.loading = false;
            state.flashDealsproducts = action.payload.flash_deal || {};
        })
        .addCase(fetchFlashDealsProductsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default flashDealsSlice.reducer;